import type { ValidationRule } from '@elements/form-validation/dist/core/index.js'

const file: ValidationRule = {
    validate: (value, param) => {
        if (!value || !param) return true
        const extension = value.split('.').pop()?.toLowerCase()
        const allowed = param
            .split(',')
            .map(entry => entry.trim().toLowerCase().replace(/^\./, ''))
            .filter(entry => entry !== '' && !entry.includes('/'))
        if (allowed.length === 0) return true
        return extension ? allowed.includes(extension) : false
    },
}

const maxFiles: ValidationRule = {
    validate: (value, param, field) => {
        if (!value || !param) return true
        const files = (field as HTMLInputElement | undefined)?.files
        if (!files) return true
        const limit = Number(param)
        if (Number.isNaN(limit)) return true
        return files.length <= limit
    },
}

const maxFileSize: ValidationRule = {
    validate: (value, param, field) => {
        if (!value || !param) return true
        const files = (field as HTMLInputElement | undefined)?.files
        if (!files) return true
        const maxKb = Number(param)
        if (Number.isNaN(maxKb)) return true
        const maxBytes = maxKb * 1024
        return Array.from(files).every(f => f.size <= maxBytes)
    },
}

const fieldsetMinCount: ValidationRule = {
    validate: (value: string, param?: string) => {
        const count = parseInt(value, 10);
        const min = parseInt(param ?? '1', 10);
        return !Number.isFinite(min) || !Number.isFinite(count) || count >= min;
    },
}

export const customValidators: Record<string, ValidationRule> = {
    file,
    maxFiles,
    maxFileSize,
    fieldsetMinCount,
}
